import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import ApprenticeshipDivisionHomeLanding from '../Components/ApprenticeshipDivision/ApprenticeshipDivisionHomeLanding';

class ApprenticeshipDivisionContainer extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));

        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">
                    <Switch>
                        <Route exact path="/apprenticeship-division" render={(props) =>
                            <ApprenticeshipDivisionHomeLanding
                                {...props}
                                history={this.props.history}
                                title="Apprenticeship Division"
                                code="APPRENTICESHIP_DIVISION"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />
                    </Switch>
                </div>
            </div>
        )
    }
}

export default withAuth(ApprenticeshipDivisionContainer);
